// videoSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IVideo, IVideoInitialState } from "./videoModal";
import {
  activeInactiveVideo,
  createVideo,
  deleteVideo,
  getAllActiveVideos,
  getAllVideos,
  getVideoByID,
  updateVideo,
} from "./services/video.service";

const initialState: IVideoInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  VideoID: null,
  VideoList: [],
  VideoDetail: {
    ID: null,
    Title: "",
    VideoURL: "",
    Tagline: "",
    Date: new Date(),
    ShortDescription: "",
    SequenceNo: 0,
    IsDisplayHome: false,
    ImageUpload: null,
    IsActive: 1,
  },
};

const videoSlice = createSlice({
  name: "video",
  initialState,
  reducers: {
    clearVideoDetails: (state) => {
      state.VideoDetail = initialState.VideoDetail;
    },
    setVideoID: (state, action) => {
      state.VideoID = action.payload;
    },
    clearVideoID: (state) => {
      state.VideoID = initialState.VideoID;
    },
  },
  extraReducers: (builder) => {
    // Get All Videos
    builder.addCase(getAllVideos.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllVideos.fulfilled,
      (state, action: PayloadAction<IVideo[]>) => {
        state.loading = false;
        state.VideoList = action.payload || [];
      },
    );
    builder.addCase(getAllVideos.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.VideoList = [];
    });

    // Create Video
    builder.addCase(createVideo.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createVideo.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createVideo.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Update Video
    builder.addCase(updateVideo.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateVideo.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateVideo.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Delete Video
    builder.addCase(deleteVideo.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteVideo.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteVideo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Get Video By ID
    builder.addCase(getVideoByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getVideoByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.VideoDetail = action.payload;
    });
    builder.addCase(getVideoByID.rejected, (state, action) => {
      state.formLoading = false;
      state.VideoDetail = initialState.VideoDetail;
      state.error = action.error.message || "Something went wrong";
    });

    // Get All Active Videos
    builder.addCase(getAllActiveVideos.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveVideos.fulfilled,
      (state, action: PayloadAction<IVideo[]>) => {
        state.loading = false;
        state.VideoList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveVideos.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.VideoList = [];
    });

    // Active/Inactive Video
    builder.addCase(activeInactiveVideo.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(activeInactiveVideo.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(activeInactiveVideo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearVideoDetails, clearVideoID, setVideoID } =
  videoSlice.actions;
export default videoSlice.reducer;
